module.exports = {
  GENERAL_APPLICATION_ERROR: 1000,
  MAXIMUM_LENGTH_EXCEEDED: 1001,
  MINIMUM_LENGTH_ERROR: 1002,
  PERMISSION_ERROR: 1003,
  REQUESTED_RESOURCE_CANNOT_BE_FOUND: 1004,
  REQUESTED_RESOURCE_CANNOT_BE_UPDATED: 1006,
  MISSING_MANDATORY_FIELD: 1007,
  INVALID_FIELD_VALUE: 1018,
  INVALID_OBJECT_TYPE: 1026,
  ID_ALREADY_EXISTS: 1027,
  FIELD_NOT_ALLOWED_FOR_RESOURCE_TYPE: 1028,
  VALUE_PROVIDED_NOT_VALID_TYPE: 1029,
  SYSTEM_FAILED_TO_PASS_AN_APP_RULE: 1030,
  MISSING_REQUIRED_FIELD: 1031,
  SECURITY_RELATED_EXCEPTION: 1033,
  SERVER_SIDE_CONFIGURATION_EXCEPTION: 1034,
  SERVER_SIDE_COMPONENT: 1035,
};
